import React, { useContext } from "react";
import { Button, Content, usePathFactory, useTranslator } from "@sia/style-guide";
import { useHistory } from "react-router-dom";
import GlobalContext from "contexts/GlobalContext";
import Page from "../../Page";
const AlreadyRegisteredPage = () => {
  const { user } = useContext(GlobalContext);
  const translate = useTranslator();
  const history = useHistory();
  const pathFactory = usePathFactory();
  return (
    <Page>
      <Content width={"slim"} centeredTitle centeredTexts>
        <h3 className="productive-heading-04 sia-text-12">
          {translate("wizard.already-registered.manage.title", {
            member: user.getOriginalMemberType(),
          })}
        </h3>
        <p>
          <Button onClick={() => history.push(pathFactory.create("account"))}>{translate("wizard.already-registered.manage.button.label")}</Button>
        </p>
      </Content>
    </Page>
  );
};

export default AlreadyRegisteredPage;
